import React, { useContext, useEffect } from "react";
import logo from "../assets/logo.png";
import UserContext from "./Authcontext";
import Footer from "./Foote/Footer";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import "./verification-page.css";

function UserVerification() {
  const { user, fetchUserData } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  useEffect(() => {
    if (user.verify === 1) {
      navigate("/", { replace: true });
    }
  }, [user.verify, navigate]);

  const handleLogout = () => {
    Cookies.remove("m_host-token");
    navigate("/signup", { replace: true });
  };

  const handleContactSupport = () => {
    // This could be implemented to open a contact form or email link
    alert("Please contact our support team at support@matrimony.com");
  };

  return (
    <>
      <div className="verification-container">
        {/* Decorative elements */}
        <div className="verification-decoration verification-decoration-1"></div>
        <div className="verification-decoration verification-decoration-2"></div>
        <div className="verification-decoration verification-decoration-3"></div>
        <div className="verification-decoration verification-decoration-4"></div>
        
        {/* Floating shapes */}
        <div className="verification-shape verification-shape-1"></div>
        <div className="verification-shape verification-shape-2"></div>
        <div className="verification-shape verification-shape-3"></div>
        
        <div className="verification-card">
          <img src={logo} alt="Matrimony" className="verification-logo" />
          
          <h1 className="verification-title">
            Welcome, <span>{user.first_name || "User"}</span>!
          </h1>
          
          <p className="verification-message">
            Thank you for completing your profile registration.
          </p>
          
          <div className="verification-status">
            <div className="verification-status-icon">
              <i className="fa fa-clock-o" aria-hidden="true"></i>
            </div>
            <h3 className="verification-status-text">Profile Under Verification</h3>
            <p className="verification-status-subtext">
              Our team is reviewing your profile to ensure a quality experience for all users.
            </p>
            
            <div className="verification-progress">
              <div className="verification-progress-bar"></div>
            </div>
            
            <p className="verification-status-subtext">
              Estimated completion time: <strong>Within 24 hours</strong>
            </p>
          </div>
          
          <div className="verification-timeline">
            <div className="verification-step completed">
              <div className="verification-step-dot">✓</div>
              <div className="verification-step-label">Profile Created</div>
            </div>
            
            <div className="verification-step active">
              <div className="verification-step-dot">2</div>
              <div className="verification-step-label">Under Review</div>
            </div>
            
            <div className="verification-step">
              <div className="verification-step-dot">3</div>
              <div className="verification-step-label">Verification Complete</div>
            </div>
          </div>
          
          <p className="verification-message">
          உங்கள் சுயவிவரம் ஒப்புதல் பெற்றவுடன், நீங்கள் தானாகவே எங்கள் திருமண இணையதளத்திற்கு வழிநடத்தப்படுவீர்கள். இந்த சரிபார்ப்பு செயல்முறை பொதுவாக 24 மணி நேரத்திற்குள் முடிவடையும்.
          <br /><br />
          உதவி தேவையா? தொடர்பு கொள்ளவும் - 7639348617
          </p>
          
          <div className="verification-buttons">
           
            <button 
              type="button" 
              className="verification-button verification-button-primary"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
          
          <p className="verification-contact">
            Have questions? <a href="#">Contact No: 7639348617</a>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UserVerification;
